import { useState, useEffect, useContext } from "react";
import { loginUser, isAuthenticated } from "../api/authService";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useParams } from "react-router-dom"; // For navigating after login
import { comfirmBooking } from "../api/bookingApi";
import { BarbershopContext } from "../providers/useProvider";
import { useAuth } from "../context/AuthContext";
const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { login } = useAuth(); // Get login function from context
  const navigate = useNavigate();

  const handleLogin = async ({ email, password }) => {
    setLoading(true);
    setError(null);

    try {
      const response = await loginUser({
        Email: email,
        Password: password,
      });
      if (response.isSuccess) {
        // Pass the token to AuthStateProvider to store it
        login(response.value.token);
        // Redirect to home page after successful login
        navigate(`/`);
      } else {
        setError(response.errors[0]);
      }
      // assuming response contains the user or token
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    error,
    handleLogin,
  };
};

export default useLogin;
